define(
    'NMSDesignSystem.Header',
    [
        'Header.View',
        'Header.Menu.View',
        'Header.Profile.View',
        'Header.Menu.MyAccount.View',
        'Header.MiniCart.View',
        'Header.MiniCartItemCell.View',
        'Header.Logo.View',
        'SiteSearch.View',
        'ItemsSearcher.View',
        'ItemsSearcher.Utils',
        'ItemsSearcher.Item.View',
        'Profile.Model',
        'LiveOrder.Model',
        'LiveOrder.Line.Model',
        'Utils',
        'Handlebars',
        'SC.Configuration',
        'Session',
        'jQuery',
        'underscore',
        'nms_header.tpl',
        'nms_header_menu.tpl',
        'nms_header_sidebar.tpl',
        'nms_header_profile.tpl',
        'nms_header_menu_myaccount.tpl',
        'nms_header_mini_cart.tpl',
        'nms_header_logo.tpl',
        'nms_site_search.tpl',
        'nms_itemssearcher_item.tpl',
        'nms_itemssearcher.tpl',
        'GlobalViews.Breadcrumb.View',
        'nms_global_views_breadcrumb.tpl'
    ],
    function NMSDesignSystemHeader(
        HeaderView,
        HeaderMenuView,
        HeaderProfileView,
        HeaderMenuMyAccountView,
        HeaderMiniCartView,
        HeaderMiniCartItemCellView,
        HeaderLogoView,
        SiteSearchView,
        ItemsSearcherView,
        ItemsSearcherUtils,
        ItemsSearcherItemView,
        ProfileModel,
        LiveOrderModel,
        LiveOrderLineModel,
        Utils,
        Handlebars,
        Configuration,
        Session,
        jQuery,
        _,
        nmsHeaderTpl,
        nmsHeaderMenuTpl,
        nmsHeaderSidebarTpl,
        nmsHeaderProfileTpl,
        nmsHeaderMenuMyAccountTpl,
        nmsHeaderMiniCartTpl,
        nmsHeaderLogoTpl,
        nmsSiteSearchTpl,
        nmsItemsSearcherItemTpl,
        nmsItemsSearcherTpl,
        BreadcrumbView,
        nmsBreadcrumbTpl
    ) {
        'use strict';

        var NMS_HEADER_MOBILE_QUERY = '(max-width: 1064px)';

        var navigationFallback = [
            {
                text: 'Products',
                route: '/products',
                children: [
                    {text: 'Prescription Medication', route: '/products/prescription-medication'},
                    {text: 'OTC Medication', route: '/products/over-the-counter-medication'},
                    {text: 'Health & Beauty', route: '/products/health-beauty'},
                    {
                        text: 'Animal Health',
                        route: '/products/animal-health/general-medications',
                        children: [
                            {text: 'General Medications', route: '/products/animal-health/general-medications'},
                            {text: 'Medical Supplies', route: '/products/animal-health/medical-supplies-ah'},
                            {text: 'Oncology Medications', route: '/products/animal-health/oncology-medications'},
                            {text: 'Best Sellers', route: '/products/animal-health/best-sellers'}
                        ]
                    },
                    {text: 'Medical Supplies', route: '/products/medical-supplies'},
                    {text: 'EMS', route: '/products/ems'},
                    {text: 'Vaccines', route: '/products/other-vaccine'},
                    {text: 'PPE', route: '/products/ppe'},
                    {text: 'Crash Cart', route: '/search?keywords=crash%20cart&display=list'}
                ]
            },
            {
                text: 'Flu Vaccines',
                href: buyFluShotsBaseUrl()
            },
            {
                text: 'Flu Reimbursement',
                href: fluReimbursementUrl()
            }
        ];
        var buyFluShotsPreviewNavigation = [
            {
                text: 'Products',
                route: '/products',
                children: [
                    {text: 'Flu Vaccines', route: '/products/flu-vaccines'},
                    {text: 'Vaccines', route: '/products/other-vaccine'},
                    {text: 'Vaccine Supplies', route: '/products/vaccine-supplies'},
                    {text: 'PPE', route: '/products/ppe'}
                ]
            },
            {
                text: 'Flu Reimbursement',
                route: '/flu-vaccine-reimbursement'
            },
            {
                text: 'Order Now',
                route: '/',
                children: [
                    {text: 'Order PDF', route: '/pre-book'},
                    {text: 'Order Web (Login Req.)', route: '/prebook'}
                ]
            }
        ];
        var accountSections = [
            {name: 'Overview', url: '/'},
            {name: 'Purchases', url: '/purchases'},
            {name: 'Billing', url: '/balance'},
            {name: 'Addresses', url: '/addressbook'},
            {name: 'Profile & Settings', url: '/profile-settings'},
            {name: 'Cases', url: '/cases'}
        ];

        function canonicalIdentifierLabel(value) {
            var label = String(value || '');

            if (label === 'SKU' || label === 'SKU:') return 'NDC/Item Number:';
            return value;
        }

        function installIdentifierTranslation() {
            var originalTranslate = Utils && Utils.translate;
            var originalHelper = Handlebars && Handlebars.helpers && Handlebars.helpers.translate;

            if (originalTranslate && !originalTranslate.nmsIdentifierTranslation) {
                Utils.translate = function translateNMSIdentifier() {
                    var args = Array.prototype.slice.call(arguments);

                    args[0] = canonicalIdentifierLabel(args[0]);
                    return originalTranslate.apply(this, args);
                };
                Utils.translate.nmsIdentifierTranslation = true;
            }

            if (originalHelper && !originalHelper.nmsIdentifierTranslation) {
                Handlebars.registerHelper('translate', function translateNMSIdentifierHelper() {
                    var args = Array.prototype.slice.call(arguments);

                    args[0] = canonicalIdentifierLabel(args[0]);
                    return originalHelper.apply(this, args);
                });
                Handlebars.helpers.translate.nmsIdentifierTranslation = true;
            }
        }

        function currentTouchpoint() {
            return Configuration.currentTouchpoint || Configuration.get('currentTouchpoint', '');
        }

        function isBuyFluShotsSite() {
            var hostname = typeof window !== 'undefined' && window.location
                ? String(window.location.hostname || '').toLowerCase()
                : '';

            return hostname === 'buyflushots.nmsincusa.com' ||
                hostname === 'buyflu-sandbox.ethanablatt.com';
        }

        function isLocalPreview() {
            return typeof window !== 'undefined' &&
                /(?:shopping|checkout|my_account)-local\.ssp$/i.test(window.location.pathname);
        }

        function isBuyFluShotsLocalPreview() {
            return isBuyFluShotsSite() && isLocalPreview();
        }

        function fluReimbursementUrl() {
            return isBuyFluShotsSite()
                ? '/flu-vaccine-reimbursement'
                : buyFluShotsBaseUrl() + 'flu-vaccine-reimbursement';
        }

        function buyFluShotsBaseUrl() {
            var hostname = typeof window !== 'undefined' && window.location
                ? String(window.location.hostname || '').toLowerCase()
                : '';

            return hostname === 'sca-sandbox.ethanablatt.com'
                ? 'https://buyflu-sandbox.ethanablatt.com/'
                : 'https://buyflushots.nmsincusa.com/';
        }

        function touchpoints() {
            return Session.get('touchpoints') || {};
        }

        function stripHash(url) {
            return String(url || '').replace(/#.*$/, '');
        }

        function absoluteHomeUrl(route) {
            var home = touchpoints().home || '/';
            var cleanRoute = String(route || '/').replace(/^#/, '');

            try {
                if (typeof window !== 'undefined' && window.location && window.location.href) {
                    home = new URL(home, window.location.href).href;
                }

                return new URL(cleanRoute, home).href;
            } catch (error) {
                return cleanRoute;
            }
        }

        function accountUrl(route) {
            var base = stripHash(touchpoints().customercenter || touchpoints().myaccount || '');
            var fragment = String(route || '/overview').replace(/^#?\/?/, '');

            return base ? base + '#/' + fragment : '#/' + fragment;
        }

        function loginUrl() {
            var base = stripHash(touchpoints().login || touchpoints().register || '');

            return base ? base + '#login-register' : '/sca-dev-2020-1/checkout.ssp?is=login&login=T#login-register';
        }

        function checkoutUrl() {
            return stripHash(touchpoints().checkout || '') || '/sca-dev-2020-1/checkout.ssp';
        }

        function logoutUrl() {
            return touchpoints().logout || '/?logoff=T';
        }

        function routeFromNavigationEntry(entry) {
            var data = (entry && entry.data) || {};
            var hashtag = entry && (entry['data-hashtag'] || entry.hashtag || data.hashtag);
            var href = entry && (entry.fullurl || entry.href || entry.route || data.href);

            if (hashtag && hashtag !== '#') return String(hashtag).replace(/^#/, '');
            return href || '/';
        }

        function normalizedNavigationText(text) {
            return String(text || '').replace(/&amp;/gi, '&').replace(/^\s+|\s+$/g, '').toLowerCase();
        }

        function canonicalProductRoute(entry, parentText, route) {
            var parent = normalizedNavigationText(parentText);
            var text = normalizedNavigationText(entry && entry.text);
            var productRoutes = {
                'prescription medication': '/products/prescription-medication',
                'prescription medications': '/products/prescription-medication',
                'otc medication': '/products/over-the-counter-medication',
                'over-the-counter medication': '/products/over-the-counter-medication',
                'health & beauty': '/products/health-beauty',
                'animal health': '/products/animal-health/general-medications',
                'medical supplies': '/products/medical-supplies',
                'ems': '/products/ems',
                'vaccines': '/products/other-vaccine',
                'ppe': '/products/ppe',
                'crash cart': '/search?keywords=crash%20cart&display=list'
            };
            var animalHealthRoutes = {
                'general medications': '/products/animal-health/general-medications',
                'medical supplies': '/products/animal-health/medical-supplies-ah',
                'oncology medications': '/products/animal-health/oncology-medications',
                'best sellers': '/products/animal-health/best-sellers'
            };
            var orderRoutes = {
                'order pdf': '/pre-book',
                'order web': '/prebook',
                'order web (login req.)': '/prebook'
            };

            // NetSuite's category record is the route authority. Label mappings
            // exist only for legacy navigation rows that do not carry a URL.
            if (route && route !== '/' && route !== '#') return route;

            if (!parent && text === 'products') return '/products';
            if (!parent && text === 'order now') return '/pre-book';
            if (parent === 'products' && productRoutes[text]) return productRoutes[text];
            if (parent === 'animal health' && animalHealthRoutes[text]) return animalHealthRoutes[text];
            if (parent === 'order now' && orderRoutes[text]) return orderRoutes[text];
            return route;
        }

        function normalizeNavigationEntry(entry, parentText) {
            var children = (entry.children || entry.categories || []).filter(function excludeNestedFlu(child) {
                return normalizedNavigationText(parentText || entry.text) !== 'products' || normalizedNavigationText(child && child.text) !== 'flu vaccines';
            });
            var route = canonicalProductRoute(entry, parentText, routeFromNavigationEntry(entry));
            var href = entry.href || route || '';
            var external;
            var fullDocument;

            if (
                window.location.hostname === 'sca-sandbox.ethanablatt.com' &&
                /^https:\/\/buyflushots\.nmsincusa\.com\//i.test(href)
            ) {
                href = href.replace(
                    /^https:\/\/buyflushots\.nmsincusa\.com\//i,
                    'https://buyflu-sandbox.ethanablatt.com/'
                );
            }

            external = /^https?:\/\//i.test(href);
            fullDocument = external || currentTouchpoint() !== 'home';

            return {
                text: entry.text,
                href: external ? href : (fullDocument ? absoluteHomeUrl(route) : route),
                route: route,
                hashtag: '#' + route.replace(/^#/, ''),
                touchpoint: 'home',
                fullDocument: fullDocument,
                children: children.map(function normalizeNavigationChild(child) {
                    return normalizeNavigationEntry(child, entry.text);
                })
            };
        }

        function normalizePreviewNavigationEntry(entry) {
            var route = routeFromNavigationEntry(entry);
            var fullDocument = currentTouchpoint() !== 'home';

            return {
                text: entry.text,
                href: fullDocument ? absoluteHomeUrl(route) : route,
                route: route,
                hashtag: '#' + route.replace(/^#/, ''),
                touchpoint: 'home',
                fullDocument: fullDocument,
                children: (entry.children || []).map(normalizePreviewNavigationEntry)
            };
        }

        function configuredNavigation() {
            if (isBuyFluShotsSite()) {
                return buyFluShotsPreviewNavigation.map(normalizePreviewNavigationEntry);
            }

            var headerNavigation = Configuration.get('nmsHeader.navigation', []);
            var configured = headerNavigation.length ? headerNavigation : (Configuration.navigationData || []);
            var products = configured.filter(function findProducts(entry) {
                return entry && entry.text && entry.text.toLowerCase() === 'products' && entry.categories && entry.categories.length;
            });
            // Main's header keeps its product navigation; flu navigation belongs to Buy Flu.
            var source = products.length ? products : navigationFallback.filter(function (entry) {
                return entry.text !== 'Flu Vaccines' && entry.text !== 'Flu Reimbursement';
            });

            return source.map(normalizeNavigationEntry);
        }

        function flattenAccountEntries(entries, result) {
            result = result || [];
            (entries || []).forEach(function addAccountEntry(entry) {
                result.push(entry);
                flattenAccountEntries(entry.children, result);
            });
            return result;
        }

        function canonicalAccountEntries(entries, useFullDocument) {
            var available = flattenAccountEntries(entries);

            return accountSections.map(function createAccountSection(section) {
                var match = available.filter(function findAccountSection(entry) {
                    return normalizedNavigationText(entry && entry.name) === normalizedNavigationText(section.name) ||
                        String(entry && entry.url || '').replace(/\/$/, '') === section.url.replace(/\/$/, '');
                })[0] || {};

                return {
                    name: section.name,
                    url: section.url,
                    href: accountUrl(section.url),
                    fullDocument: useFullDocument,
                    permission: match.permission,
                    permissionOperator: match.permissionOperator,
                    children: []
                };
            });
        }

        function wrapContext(View, extension) {
            var prototype = View && View.prototype;
            var original;

            if (!prototype || prototype.nmsHeaderContextInstalled) return;

            original = prototype.getContext;
            prototype.getContext = function getNMSHeaderContext() {
                return extension.call(this, original.apply(this, arguments));
            };
            prototype.nmsHeaderContextInstalled = true;
        }

        function readContextValue(source, key) {
            if (!source) return undefined;
            if (typeof source.get === 'function') return source.get(key);
            return source[key];
        }

        function firstPresentValue(values) {
            var match;

            (values || []).some(function findPresentValue(value) {
                if (value === undefined || value === null || String(value).trim() === '') return false;
                match = value;
                return true;
            });
            return match;
        }

        function miniCartLineSku(view, context) {
            var modelLine = view && view.model;
            var modelItem = readContextValue(modelLine, 'item');
            var contextLine = context && context.line;
            var contextItem = readContextValue(contextLine, 'item');

            return firstPresentValue([
                readContextValue(modelItem, 'itemid'),
                readContextValue(modelItem, '_sku'),
                readContextValue(modelItem, 'sku'),
                readContextValue(modelItem, 'vendorcode'),
                readContextValue(contextItem, 'itemid'),
                readContextValue(contextItem, '_sku'),
                readContextValue(contextItem, 'sku'),
                readContextValue(contextItem, 'vendorcode')
            ]);
        }

        function miniCartLineProductName(view, context) {
            var modelLine = view && view.model;
            var modelItem = readContextValue(modelLine, 'item');
            var contextLine = context && context.line;
            var contextItem = readContextValue(contextLine, 'item');

            return firstPresentValue([
                readContextValue(modelItem, 'storedisplayname2'),
                readContextValue(contextItem, 'storedisplayname2'),
                readContextValue(modelItem, 'displayname'),
                readContextValue(contextItem, 'displayname'),
                readContextValue(modelItem, '_name'),
                readContextValue(contextItem, '_name'),
                readContextValue(modelItem, 'itemid'),
                readContextValue(contextItem, 'itemid')
            ]);
        }

        function installTemplates() {
            BreadcrumbView.prototype.template = nmsBreadcrumbTpl;
            HeaderView.prototype.template = nmsHeaderTpl;
            HeaderMenuView.prototype.template = function nmsResponsiveHeaderMenuTemplate(context) {
                return (window.matchMedia(NMS_HEADER_MOBILE_QUERY).matches ? nmsHeaderSidebarTpl : nmsHeaderMenuTpl)(context);
            };
            HeaderProfileView.prototype.template = nmsHeaderProfileTpl;
            HeaderMenuMyAccountView.prototype.template = nmsHeaderMenuMyAccountTpl;
            HeaderMiniCartView.prototype.template = nmsHeaderMiniCartTpl;
            HeaderMiniCartItemCellView.prototype.template = nmsHeaderMiniCartTpl;
            HeaderLogoView.prototype.template = nmsHeaderLogoTpl;
            SiteSearchView.prototype.template = nmsSiteSearchTpl;
        }

        function installContexts() {
            wrapContext(HeaderMenuView, function extendMenuContext(context) {
                context.nmsNavigation = configuredNavigation();
                return context;
            });

            wrapContext(HeaderProfileView, function extendProfileContext(context) {
                context.loginUrl = loginUrl();
                context.accountUrl = accountUrl('/overview');
                return context;
            });

            wrapContext(HeaderMenuMyAccountView, function extendAccountMenuContext(context) {
                var fullDocument = currentTouchpoint() !== 'customercenter' && currentTouchpoint() !== 'myaccount';
                var profile = ProfileModel.getInstance();

                context.displayName = profile.get('firstname') || profile.get('companyname') || 'My Account';
                context.logoutUrl = logoutUrl();
                context.entries = canonicalAccountEntries(context.entries, fullDocument);
                return context;
            });

            wrapContext(HeaderMiniCartView, function extendMiniCartContext(context) {
                context.cartFullDocument = currentTouchpoint() !== 'home';
                context.cartUrl = context.cartFullDocument ? (touchpoints().viewcart || absoluteHomeUrl('/cart')) : '#cart';
                context.checkoutUrl = checkoutUrl();
                return context;
            });

            wrapContext(HeaderMiniCartItemCellView, function extendMiniCartItemContext(context) {
                context.nmsIsMiniCartItem = true;
                context.lineInternalId = context.line && context.line.internalid;
                context.lineSku = miniCartLineSku(this, context);
                context.nmsProductName = normalizeSearchResultName(miniCartLineProductName(this, context));
                context.loginUrl = loginUrl();
                context.nmsCanEditLine = !context.isFreeGift;
                return context;
            });

            wrapContext(HeaderLogoView, function extendLogoContext(context) {
                context.headerFullDocument = currentTouchpoint() !== 'home';
                context.headerUrl = context.headerFullDocument ? absoluteHomeUrl('/') : (context.headerLinkHref || '/');
                return context;
            });
        }

        var nmsEscapeReleaseInstalled = false;

        function installNMSCancelledEscapeKeyup() {
            if (nmsEscapeReleaseInstalled || typeof document === 'undefined' || typeof window === 'undefined') return;
            nmsEscapeReleaseInstalled = true;
            var pendingEscape;

            // Observe the original keydown; later view handlers may cancel it.
            // Consume only our open overlays; the gallery owns its separate keyup handler.
            // Preserve the CMS shortcut for an Escape no NMS overlay has handled.
            document.addEventListener('keydown', function observeNMSEscapeKeydown(event) {
                if (event.key !== 'Escape') return;
                if (!event.repeat || !pendingEscape) {
                    var main = document.getElementById('main');
                    var body = document.body;
                    var miniCart = document.querySelector('.nms-header-mini-cart');
                    var lightbox = document.querySelector('.nms-pdp-lightbox:not([hidden])');
                    pendingEscape = {
                        event: event,
                        owned: !lightbox && !!((main && main.classList.contains('header-sidebar-opened')) ||
                            (body && (body.classList.contains('nms-account-sheet-open') ||
                                body.classList.contains('nms-products-category-sheet-open'))) ||
                            (miniCart && miniCart.closest('.open')))
                    };
                }
            }, true);
            window.addEventListener('keyup', function consumeNMSCancelledEscapeRelease(event) {
                if (event.key !== 'Escape') return;
                var handled = pendingEscape && pendingEscape.owned && pendingEscape.event.defaultPrevented;
                pendingEscape = null;
                if (!handled) return;
                event.preventDefault();
                event.stopImmediatePropagation();
            }, true);
            window.addEventListener('blur', function resetNMSEscapeRelease() {
                pendingEscape = null;
            });
        }

        function installResolvedEventMap(View) {
            var originalGetEvents = View.prototype.getEvents;

            // SCA 26 spreads getEvents() into a plain object during each render.
            // Backbone also supports function-valued events; resolve those here
            // so native rendering retains the delegated NMS and native handlers.
            if (typeof originalGetEvents !== 'function' ||
                Object.prototype.hasOwnProperty.call(View.prototype, 'nmsResolvedEventMapInstalled')) return;
            View.prototype.getEvents = function getNMSResolvedEvents() {
                var events = originalGetEvents.apply(this, arguments);

                return typeof events === 'function' ? events.apply(this, arguments) : (events || {});
            };
            View.prototype.nmsResolvedEventMapInstalled = true;
        }

        function mergedEvents(originalEvents, view) {
            var nativeEvents = typeof originalEvents === 'function' ? originalEvents.apply(view) : originalEvents;
            var events = {};

            Object.keys(nativeEvents || {}).forEach(function copyEvent(key) {
                events[key] = nativeEvents[key];
            });
            return events;
        }

        function installMenuBehavior() {
            var originalEvents;
            var originalInitialize;
            var originalDestroy;

            if (HeaderMenuView.prototype.nmsHeaderBehaviorInstalled) return;

            originalEvents = HeaderMenuView.prototype.events || {};
            originalInitialize = HeaderMenuView.prototype.initialize;
            originalDestroy = HeaderMenuView.prototype.destroy;

            HeaderMenuView.prototype.initialize = function initializeNMSHeaderMenu() {
                var result = originalInitialize && originalInitialize.apply(this, arguments);
                var view = this;
                var namespace = '.nmsResponsiveHeaderMenu' + this.cid;

                this.nmsHeaderMenuIsMobile = window.matchMedia(NMS_HEADER_MOBILE_QUERY).matches;
                this.nmsHeaderMenuResizeNamespace = namespace;
                this.nmsHeaderMenuResizeHandler = _.debounce(function rerenderNMSHeaderMenuAtBreakpoint() {
                    var isMobile = window.matchMedia(NMS_HEADER_MOBILE_QUERY).matches;

                    if (isMobile === view.nmsHeaderMenuIsMobile) return;
                    view.nmsHeaderMenuIsMobile = isMobile;
                    view.render();
                }, 100);
                jQuery(window).on('resize' + namespace, this.nmsHeaderMenuResizeHandler);
                return result;
            };

            HeaderMenuView.prototype.destroy = function destroyNMSHeaderMenu() {
                if (this.nmsHeaderMenuResizeNamespace) jQuery(window).off(this.nmsHeaderMenuResizeNamespace);
                return originalDestroy && originalDestroy.apply(this, arguments);
            };
            HeaderMenuView.prototype.events = function nmsHeaderMenuEvents() {
                var events = mergedEvents(originalEvents, this);

                events['mouseenter .nms-header-products-list > .nms-header-products-item'] = 'positionNMSMenuSelector';
                events['focusin .nms-header-products-list > .nms-header-products-item'] = 'positionNMSMenuSelector';
                events['mouseenter .nms-header-products-submenu > li'] = 'positionNMSMenuSelector';
                events['focusin .nms-header-products-submenu > li'] = 'positionNMSMenuSelector';
                events['mouseleave .nms-header-products-list'] = 'clearNMSMenuSelector';
                events['mouseleave .nms-header-products-submenu'] = 'clearNMSMenuSelector';
                events['focusout .nms-header-products-list'] = 'clearNMSMenuSelector';
                events['focusout .nms-header-products-submenu'] = 'clearNMSMenuSelector';
                return events;
            };

            HeaderMenuView.prototype.positionNMSMenuSelector = function positionNMSMenuSelector(event) {
                var item = this.$(event.currentTarget);
                var list = item.parent();
                var selector = list.children('.nms-header-products-selector').first();

                if (!selector.length) return;
                list.css({
                    '--nms-header-selector-y': item.position().top + 'px',
                    '--nms-header-selector-height': item.outerHeight() + 'px'
                }).addClass('is-selecting');
            };

            HeaderMenuView.prototype.clearNMSMenuSelector = function clearNMSMenuSelector(event) {
                var list = this.$(event.currentTarget);
                var nextTarget = event.relatedTarget;

                if (nextTarget && (list[0] === nextTarget || jQuery.contains(list[0], nextTarget))) return;
                list.removeClass('is-selecting');
            };

            HeaderMenuView.prototype.nmsHeaderBehaviorInstalled = true;
        }

        function installAccountMenuBehavior() {
            var originalEvents;

            if (HeaderMenuMyAccountView.prototype.nmsHeaderBehaviorInstalled) return;

            originalEvents = HeaderMenuMyAccountView.prototype.events || {};
            HeaderMenuMyAccountView.prototype.events = function nmsHeaderAccountMenuEvents() {
                var events = mergedEvents(originalEvents, this);

                events['mouseenter .nms-header-account-section'] = 'positionNMSAccountSelector';
                events['focusin .nms-header-account-section'] = 'positionNMSAccountSelector';
                events['mouseleave .nms-header-account-sections'] = 'clearNMSAccountSelector';
                events['focusout .nms-header-account-sections'] = 'clearNMSAccountSelector';
                return events;
            };

            HeaderMenuMyAccountView.prototype.positionNMSAccountSelector = function positionNMSAccountSelector(event) {
                var item = this.$(event.currentTarget);
                var list = item.parent();
                var selector = list.children('.nms-header-account-selector').first();

                if (!selector.length) return;
                list.css({
                    '--nms-header-selector-y': item.position().top + 'px',
                    '--nms-header-selector-height': item.outerHeight() + 'px'
                }).addClass('is-selecting');
            };

            HeaderMenuMyAccountView.prototype.clearNMSAccountSelector = function clearNMSAccountSelector(event) {
                var list = this.$(event.currentTarget);
                var nextTarget = event.relatedTarget;

                if (nextTarget && (list[0] === nextTarget || jQuery.contains(list[0], nextTarget))) return;
                list.removeClass('is-selecting');
            };

            HeaderMenuMyAccountView.prototype.nmsHeaderBehaviorInstalled = true;
        }

        function installBehavior() {
            var originalShowSidebar;
            var originalHideSidebar;
            var originalEvents;

            if (HeaderView.prototype.nmsHeaderBehaviorInstalled) return;

            originalShowSidebar = HeaderView.prototype.showSidebar;
            originalHideSidebar = HeaderView.prototype.hideSidebar;
            originalEvents = HeaderView.prototype.events || {};

            HeaderView.prototype.events = function nmsHeaderEvents() {
                var nativeEvents = typeof originalEvents === 'function' ? originalEvents.apply(this, arguments) : originalEvents;
                var events = {};

                Object.keys(nativeEvents || {}).forEach(function copyHeaderEvent(key) {
                    events[key] = nativeEvents[key];
                });
                events['click [data-action="header-sidebar-show"]'] = 'showSidebar';
                events['click [data-action="header-sidebar-hide"]'] = 'hideSidebar';
                events['click [data-action="navigate-menu"]'] = 'hideSidebar';
                events['click [data-action="toggle-mobile-submenu"]'] = 'toggleNMSMobileSubmenu';
                events['click .nms-header-sidebar-account a'] = 'hideSidebar';
                events['keydown .nms-header-nav'] = 'handleNMSMobileMenuKeydown';
                // Header child views can already exist when an extension mounts.
                // Delegate the desktop selector glide from the stable Header root
                // so it remains available after either dropdown is re-rendered.
                events['mouseenter .nms-header-products-list > .nms-header-products-item'] = 'positionNMSHeaderSelector';
                events['focusin .nms-header-products-list > .nms-header-products-item'] = 'positionNMSHeaderSelector';
                events['mouseenter .nms-header-products-submenu > li'] = 'positionNMSHeaderSelector';
                events['focusin .nms-header-products-submenu > li'] = 'positionNMSHeaderSelector';
                events['mouseenter .nms-header-account-section'] = 'positionNMSHeaderSelector';
                events['focusin .nms-header-account-section'] = 'positionNMSHeaderSelector';
                events['mouseleave .nms-header-products-list'] = 'clearNMSHeaderSelector';
                events['mouseleave .nms-header-products-submenu'] = 'clearNMSHeaderSelector';
                events['mouseleave .nms-header-account-sections'] = 'clearNMSHeaderSelector';
                events['focusout .nms-header-products-list'] = 'clearNMSHeaderSelector';
                events['focusout .nms-header-products-submenu'] = 'clearNMSHeaderSelector';
                events['focusout .nms-header-account-sections'] = 'clearNMSHeaderSelector';
                return events;
            };

            HeaderView.prototype.positionNMSHeaderSelector = function positionNMSHeaderSelector(event) {
                var item = this.$(event.currentTarget);
                var list = item.parent();
                var selector = list.children('.nms-header-products-selector, .nms-header-account-selector').first();

                if (!selector.length) return;
                list.css({
                    '--nms-header-selector-y': item.position().top + 'px',
                    '--nms-header-selector-height': item.outerHeight() + 'px'
                }).addClass('is-selecting');
            };

            HeaderView.prototype.clearNMSHeaderSelector = function clearNMSHeaderSelector(event) {
                var list = this.$(event.currentTarget);
                var nextTarget = event.relatedTarget;

                if (nextTarget && (list[0] === nextTarget || jQuery.contains(list[0], nextTarget))) return;
                list.removeClass('is-selecting');
            };

            HeaderView.prototype.setNMSMobileMenuToggleState = function setNMSMobileMenuToggleState(isOpen) {
                this.$('[data-action="header-sidebar-show"]')
                    .attr('aria-expanded', isOpen ? 'true' : 'false')
                    .attr('aria-label', isOpen ? 'Close menu' : 'Open menu');
            };

            HeaderView.prototype.showSidebar = function showNMSHeaderSidebar(event) {
                if (jQuery('#main').hasClass('header-sidebar-opened')) {
                    return this.hideSidebar(event);
                }

                var result = originalShowSidebar.apply(this, arguments);

                this.setNMSMobileMenuToggleState(true);
                this.$('.nms-header-mobile-panel-scroll').scrollTop(0);
                return result;
            };

            HeaderView.prototype.hideSidebar = function hideNMSHeaderSidebar(event) {
                var expandedItems = this.$('.nms-header-mobile-group.is-expanded, .nms-header-mobile-submenu-item.is-expanded');
                var result = originalHideSidebar.apply(this, arguments);

                this.setNMSMobileMenuToggleState(false);
                expandedItems
                    .removeClass('is-expanded')
                    .children('.nms-header-mobile-link-row')
                    .find('[data-action="toggle-mobile-submenu"]')
                    .attr('aria-expanded', 'false');
                return result;
            };

            HeaderView.prototype.toggleNMSMobileSubmenu = function toggleNMSMobileSubmenu(event) {
                var toggle = this.$(event.currentTarget);
                var item = toggle.closest('.nms-header-mobile-group, .nms-header-mobile-submenu-item');
                var isExpanded = !item.hasClass('is-expanded');

                event.preventDefault();
                event.stopPropagation();
                item.toggleClass('is-expanded', isExpanded);
                toggle.attr('aria-expanded', isExpanded ? 'true' : 'false');
            };

            HeaderView.prototype.handleNMSMobileMenuKeydown = function handleNMSMobileMenuKeydown(event) {
                if (event.key !== 'Escape' || !jQuery('#main').hasClass('header-sidebar-opened')) return;

                event.preventDefault();
                this.hideSidebar(event);
                this.$('[data-action="header-sidebar-show"]').focus();
            };

            HeaderView.prototype.nmsHeaderBehaviorInstalled = true;
        }

        function installMiniCartBehavior() {
            var originalEvents;
            var originalInitialize;
            var originalRender;
            var originalDestroy;

            if (HeaderMiniCartView.prototype.nmsHeaderBehaviorInstalled) return;

            originalEvents = HeaderMiniCartView.prototype.events || {};
            originalInitialize = HeaderMiniCartView.prototype.initialize;
            originalRender = HeaderMiniCartView.prototype.render;
            originalDestroy = HeaderMiniCartView.prototype.destroy;
            HeaderMiniCartView.prototype.events = function nmsHeaderMiniCartEvents() {
                var events = mergedEvents(originalEvents, this);

                events['click [data-type="mini-cart"]'] = 'toggleNMSMiniCart';
                events['click .nms-header-mini-cart'] = 'preserveNMSMiniCartInteraction';
                return events;
            };

            HeaderMiniCartView.prototype.initialize = function initializeNMSMiniCart() {
                var result = originalInitialize && originalInitialize.apply(this, arguments);
                var namespace = '.nmsHeaderMiniCart' + this.cid;
                var self = this;

                this.nmsMiniCartNamespace = namespace;
                jQuery(document)
                    .on('click' + namespace, function closeNMSMiniCartFromOutside(event) {
                        if (!self.el || self.el === event.target || jQuery.contains(self.el, event.target)) return;
                        self.closeNMSMiniCart();
                    })
                    .on('keydown' + namespace, function closeNMSMiniCartOnEscape(event) {
                        if (event.key !== 'Escape' || !self.$('[data-type="mini-cart"]').parent().hasClass('open')) return;

                        event.preventDefault();
                        self.closeNMSMiniCart();
                        self.$('[data-type="mini-cart"]').focus();
                    });
                return result;
            };

            HeaderMiniCartView.prototype.render = function renderNMSMiniCart() {
                var result = originalRender ? originalRender.apply(this, arguments) : this;
                var isOpen = this.$('[data-type="mini-cart"]').parent().hasClass('open');
                var self = this;
                var container = this.$('[data-type="mini-cart"]').parent();

                this.$('[data-type="mini-cart"]').attr('aria-expanded', isOpen ? 'true' : 'false');
                // Closed cart geometry is not needed during application startup.
                // Native shown and explicit toggle paths initialize edges on opening.
                if (isOpen) this.bindNMSMiniCartScrollEdges();
                container
                    .off('shown.bs.dropdown.nmsHeaderMiniCartEdges')
                    .on('shown.bs.dropdown.nmsHeaderMiniCartEdges', function updateEdgesAfterNativeOpen() {
                        self.bindNMSMiniCartScrollEdges();
                    });
                return result;
            };

            HeaderMiniCartView.prototype.destroy = function destroyNMSMiniCart() {
                if (this.nmsMiniCartNamespace) jQuery(document).off(this.nmsMiniCartNamespace);
                this.$('[data-type="mini-cart"]')
                    .parent()
                    .off('shown.bs.dropdown.nmsHeaderMiniCartEdges');
                return originalDestroy ? originalDestroy.apply(this, arguments) : this.remove();
            };

            HeaderMiniCartView.prototype.closeNMSMiniCart = function closeNMSMiniCart() {
                this.$('[data-type="mini-cart"]').parent().removeClass('open');
                this.$('[data-type="mini-cart"]').attr('aria-expanded', 'false');
            };

            HeaderMiniCartView.prototype.preserveNMSMiniCartInteraction = function preserveNMSMiniCartInteraction(event) {
                if (!jQuery(event.target).closest('a[href]').length) event.stopPropagation();
                else this.closeNMSMiniCart();
            };

            HeaderMiniCartView.prototype.updateNMSMiniCartScrollEdges = function updateNMSMiniCartScrollEdges(event) {
                var lines = event && event.currentTarget ? this.$(event.currentTarget) : this.$('.nms-header-mini-cart-lines');
                var element = lines[0];
                var maximumScroll;

                if (!element || !this.$('[data-type="mini-cart"]').parent().hasClass('open')) return;
                maximumScroll = Math.max(0, element.scrollHeight - element.clientHeight);
                lines
                    .toggleClass('is-at-start', element.scrollTop <= 1)
                    .toggleClass('is-at-end', element.scrollTop >= maximumScroll - 1);
            };

            HeaderMiniCartView.prototype.bindNMSMiniCartScrollEdges = function bindNMSMiniCartScrollEdges() {
                var self = this;
                var lines = this.$('.nms-header-mini-cart-lines');

                lines
                    .off('scroll.nmsHeaderMiniCartEdges')
                    .on('scroll.nmsHeaderMiniCartEdges', function updateEdgesFromNativeScroll(event) {
                        self.updateNMSMiniCartScrollEdges(event);
                    });
                this.updateNMSMiniCartScrollEdges();
            };

            HeaderMiniCartView.prototype.toggleNMSMiniCart = function toggleNMSMiniCart(event) {
                var shouldShowDropdown = !Utils.isPhoneDevice() || Configuration.get('addToCartBehavior') === 'showMiniCart';
                var container;
                var isOpen;

                event.preventDefault();
                event.stopPropagation();

                if (!shouldShowDropdown) {
                    window.location.assign(touchpoints().viewcart || absoluteHomeUrl('/cart'));
                    return;
                }

                container = this.$('[data-type="mini-cart"]').parent();
                isOpen = !container.hasClass('open');
                container.toggleClass('open', isOpen);
                this.$('[data-type="mini-cart"]').attr('aria-expanded', isOpen ? 'true' : 'false');
                if (isOpen) this.bindNMSMiniCartScrollEdges();
            };
            HeaderMiniCartView.prototype.nmsHeaderBehaviorInstalled = true;
        }

        function installLineUpdateErrorRecovery() {
            var prototype = LiveOrderLineModel && LiveOrderLineModel.prototype;
            var originalSync;

            if (!prototype || typeof prototype.sync !== 'function' ||
                prototype.nmsLineUpdateErrorRecovery) {
                return;
            }

            originalSync = prototype.sync;
            prototype.sync = function syncNMSCartLine(method) {
                var request = originalSync.apply(this, arguments);

                if (method === 'update' && request && typeof request.fail === 'function') {
                    // Native LiveOrder and Cart failure callbacks parse responseText
                    // without a catch and require errorDetails. Register first so
                    // an empty transport error cannot stop their rollback/cleanup.
                    // Keep the same rejected jqXHR, status, headers and success path.
                    request.fail(function normalizeNMSCartLineError(xhr) {
                        var response;

                        if (!xhr || typeof xhr !== 'object') {
                            return;
                        }

                        try {
                            try {
                                response = JSON.parse(xhr.responseText);
                            } catch (parseError) {
                                response = null;
                            }

                            if (response && typeof response === 'object' &&
                                !Array.isArray(response) && response.errorDetails &&
                                typeof response.errorDetails === 'object' &&
                                !Array.isArray(response.errorDetails)) {
                                return;
                            }

                            response = response && typeof response === 'object' &&
                                !Array.isArray(response) ? response : {};
                            response.errorDetails = {};
                            xhr.responseText = JSON.stringify(response);
                        } catch (normalizationError) {
                            // A non-writable/nonstandard response must not make
                            // this optional adapter throw into the callback queue.
                        }
                    });
                }

                return request;
            };
            prototype.nmsLineUpdateErrorRecovery = true;
        }

        function installMiniCartItemBehavior() {
            var originalEvents;

            if (HeaderMiniCartItemCellView.prototype.nmsHeaderBehaviorInstalled) return;

            originalEvents = HeaderMiniCartItemCellView.prototype.events || {};
            HeaderMiniCartItemCellView.prototype.events = function nmsHeaderMiniCartItemEvents() {
                var events = mergedEvents(originalEvents, this);

                events['change [data-action="nms-mini-cart-quantity"]'] = 'updateNMSMiniCartQuantity';
                events['click [data-action="nms-mini-cart-remove"]'] = 'removeNMSMiniCartLine';
                return events;
            };

            HeaderMiniCartItemCellView.prototype.updateNMSMiniCartQuantity = function updateNMSMiniCartQuantity(event) {
                var input = this.$(event.currentTarget);
                var quantity = Math.max(1, parseInt(input.val(), 10) || 1);
                var originalQuantity = this.model.get('quantity');
                var line = this.model;
                var request;

                input.val(quantity);
                if (quantity === originalQuantity) return;
                input.prop('disabled', true);
                line.set('quantity', quantity);
                try {
                    // The line service returns the whole order; its native parent owns that response.
                    request = LiveOrderModel.getInstance().updateLine(line);
                } catch (error) {
                    line.set('quantity', originalQuantity);
                    input.val(originalQuantity).prop('disabled', false);
                    throw error;
                }
                if (request && request.fail) request.fail(function restoreQuantity() {
                    line.set('quantity', originalQuantity);
                    input.val(originalQuantity);
                });
                if (request && request.always) {
                    request.always(function enableQuantity() {
                        input.prop('disabled', false);
                    });
                } else input.prop('disabled', false);
            };

            HeaderMiniCartItemCellView.prototype.removeNMSMiniCartLine = function removeNMSMiniCartLine(event) {
                var button = this.$(event.currentTarget);
                var request;

                event.preventDefault();
                button.prop('disabled', true);
                try {
                    request = LiveOrderModel.getInstance().removeLine(this.model);
                } catch (error) {
                    button.prop('disabled', false);
                    throw error;
                }
                if (request && request.always) request.always(function enableRemove() {
                    button.prop('disabled', false);
                });
                else button.prop('disabled', false);
            };

            HeaderMiniCartItemCellView.prototype.nmsHeaderBehaviorInstalled = true;
        }

        function normalizeSearchResultName(name) {
            if (!name || /[a-z]/.test(name)) return name;

            return String(name)
                .toLowerCase()
                .replace(/(^|[\s/(-])([a-z])/g, function capitalizeWord(match, prefix, letter) {
                    return prefix + letter.toUpperCase();
                })
                .replace(/\b(\d+(?:\.\d+)?)(mg|ml|cc|bx|ct|pk|gm|gx)\b/gi, function restoreUnit(match, amount, unit) {
                    return amount + unit.toUpperCase();
                });
        }

        function installItemsSearcherTypography() {
            var prototype = ItemsSearcherItemView && ItemsSearcherItemView.prototype;
            var nativeGetContext;

            if (!prototype || prototype.nmsHeaderTypographyInstalled) return;

            nativeGetContext = prototype.getContext;
            prototype.getContext = function nmsItemsSearcherGetContext() {
                var context = nativeGetContext.apply(this, arguments);
                var sourceModel = this.model || (context && context.model);
                var sourceItem = readContextValue(sourceModel, 'item') ||
                    (sourceModel && typeof sourceModel.getItem === 'function' && sourceModel.getItem()) ||
                    sourceModel;
                var model = sourceModel && sourceModel.toJSON ? sourceModel.toJSON() : sourceModel || {};
                var mergedModel = jQuery.extend({}, model);
                var displayName = firstPresentValue([
                    readContextValue(sourceItem, 'storedisplayname2'),
                    readContextValue(sourceItem, 'displayname'),
                    readContextValue(sourceItem, '_name'),
                    readContextValue(sourceModel, 'storedisplayname2'),
                    readContextValue(sourceModel, 'displayname'),
                    readContextValue(sourceModel, '_name'),
                    readContextValue(sourceModel, 'itemid')
                ]);

                if (context) {
                    context.displayName = normalizeSearchResultName(displayName || '');
                    mergedModel.displayname = context.displayName;
                    mergedModel._url = firstPresentValue([
                        readContextValue(sourceItem, '_url'),
                        readContextValue(sourceItem, 'urlcomponent'),
                        readContextValue(sourceModel, '_url'),
                        readContextValue(sourceModel, 'urlcomponent'),
                        readContextValue(sourceModel, 'url')
                    ]) || '';
                    mergedModel._sku = firstPresentValue([
                        sourceModel && typeof sourceModel.getSku === 'function' && sourceModel.getSku(),
                        readContextValue(sourceItem, '_sku'),
                        readContextValue(sourceItem, 'itemid'),
                        readContextValue(sourceItem, 'internalid'),
                        readContextValue(sourceModel, '_sku'),
                        readContextValue(sourceModel, 'itemid'),
                        readContextValue(sourceModel, 'internalid')
                    ]) || '';
                    mergedModel._thumbnail = firstPresentValue([
                        sourceModel && typeof sourceModel.getThumbnail === 'function' && sourceModel.getThumbnail(),
                        readContextValue(sourceItem, '_thumbnail'),
                        readContextValue(sourceModel, '_thumbnail')
                    ]) || {
                        url: Utils.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg'),
                        altimagetext: context.displayName
                    };
                    context.model = mergedModel;
                }

                return context;
            };

            var nativeRender = prototype.render;
            prototype.render = function nmsItemsSearcherTypographyRender() {
                this.template = nmsItemsSearcherItemTpl;
                var result = nativeRender.apply(this, arguments);
                var $title = this.$('.itemssearcher-item-results-title');

                if ($title.length) {
                    $title.text(normalizeSearchResultName(jQuery.trim($title.text())));
                }

                return result;
            };
            prototype.template = nmsItemsSearcherItemTpl;
            prototype.nmsHeaderTypographyInstalled = true;
        }

        function installItemsSearcherSearchStability() {
            var prototype = ItemsSearcherView && ItemsSearcherView.prototype;
            var nativeGetTypeAheadConfiguration;

            if (!prototype || prototype.nmsHeaderSearchStabilityInstalled) return;

            nativeGetTypeAheadConfiguration = prototype.getTypeAheadConfiguration;
            prototype.getTypeAheadConfiguration = function nmsItemsSearcherTypeAheadConfiguration() {
                var configuration = nativeGetTypeAheadConfiguration.apply(this, arguments);

                configuration.source = _.bind(this.loadNMSStableSuggestionItemsSource, this);
                return configuration;
            };

            function centerNMSStableSearchMenus() {
                var nav = jQuery('.nms-header-nav').first()[0];
                var navRect;

                if (!nav) return;
                navRect = nav.getBoundingClientRect();

                jQuery('.nms-header-site-search .tt-menu').each(function centerNMSStableSearchMenu() {
                    var menu = this;
                    var parent = menu.offsetParent;
                    var desiredLeft;
                    var baseLeft;

                    if (!parent || !menu.offsetWidth || window.getComputedStyle(menu).display === 'none') return;

                    desiredLeft = navRect.left + (navRect.width - menu.offsetWidth) / 2;
                    baseLeft = parent.getBoundingClientRect().left + menu.offsetLeft;
                    menu.style.transform = 'translateX(' + (desiredLeft - baseLeft) + 'px)';
                });
            }

            if (!prototype.nmsHeaderSearchMenuCenterInstalled) {
                window.addEventListener('resize', centerNMSStableSearchMenus);
                prototype.nmsHeaderSearchMenuCenterInstalled = true;
            }

            prototype.loadNMSStableSuggestionItemsSource = function loadNMSStableSuggestionItemsSource(query, sync, async) {
                var view = this;
                var formattedQuery = ItemsSearcherUtils.formatKeywords(query);
                var requestId = (view.nmsSearchRequestId || 0) + 1;
                var previousCollection = view.collection;
                var previousIds = previousCollection ? view.getItemIds(previousCollection) : [];
                var labels;

                view.nmsSearchRequestId = requestId;
                if (view.nmsSearchTimer) {
                    window.clearTimeout(view.nmsSearchTimer);
                    view.nmsSearchTimer = null;
                }
                if (view.nmsSearchRequest && view.nmsSearchRequest.abort) view.nmsSearchRequest.abort();
                view.options.ajaxDone = false;
                view.options.query = formattedQuery;

                if (formattedQuery.length < view.options.minLength) {
                    view.options.labels = [];
                    view.nmsSearchRequest = null;
                    sync([]);
                    return;
                }

                labels = view.options.showSeeAll ? ['see-all-' + formattedQuery].concat(previousIds) : previousIds;
                if (!labels.length) labels = ['see-all-' + formattedQuery];
                view.options.labels = labels;
                sync(labels);
                centerNMSStableSearchMenus();

                view.nmsSearchTimer = window.setTimeout(function nmsStableSearchRequest() {
                    var nextCollection = new view.options.collection([], view.options.collectionOptions);

                    if (requestId !== view.nmsSearchRequestId) return;

                    view.nmsSearchTimer = null;
                    view.nmsSearchRequest = nextCollection.fetch({
                        data: {
                            q: String(formattedQuery).trim(),
                            sort: view.options.sort,
                            limit: view.options.limit,
                            offset: 0
                        },
                        killerId: _.uniqueId('ajax_killer_'),
                        global: false,
                        silent: true
                    });

                    if (!view.nmsSearchRequest || !view.nmsSearchRequest.done) return;

                    view.nmsSearchRequest.done(function nmsStableSearchDone() {
                        var currentQuery = ItemsSearcherUtils.formatKeywords(view.getCurrentQuery());

                        if (requestId !== view.nmsSearchRequestId || currentQuery !== formattedQuery) return;

                        view.collection = view.postItemsSuggestionObtained.executeAll(nextCollection, view.options) || nextCollection;
                        view.options.ajaxDone = true;
                        view.options.labels = view.options.showSeeAll
                            ? ['see-all-' + formattedQuery].concat(view.getItemIds(view.collection))
                            : view.getItemIds(view.collection);
                        if (!view.options.labels.length) view.options.labels = ['see-all-' + formattedQuery];
                        view.nmsSearchRequest = null;
                        renderNMSStableSuggestions(view, view.options.labels, async);
                        centerNMSStableSearchMenus();
                        view.selectFirstIfRequire();
                    }).fail(function nmsStableSearchFailed() {
                        if (requestId === view.nmsSearchRequestId) view.nmsSearchRequest = null;
                    });
                }, 160);
            };

            function renderNMSStableSuggestions(view, labels, async) {
                var typeahead = view.$searchElement && view.$searchElement.data('ttTypeahead');
                var dataset = typeahead && typeahead.menu && typeahead.menu.datasets[0];

                if (dataset && dataset._overwrite) {
                    dataset._overwrite(view.getCurrentQuery(), labels);
                } else {
                    async(labels);
                }
            }

            prototype.nmsHeaderSearchStabilityInstalled = true;
        }

        var nmsLoadingTimers = {
            show: null,
            complete: null,
            hide: null
        };
        var nmsLoadingVisible = false;
        var nmsLoadingStartedAt = 0;

        function nmsLoadingNav() {
            return jQuery('.nms-header-nav').first();
        }

        function ensureNMSLoadingIndicator() {
            var nav = nmsLoadingNav();
            var progress;

            if (!nav.length) return jQuery();
            progress = nav.find('.nms-header-loading').first();
            if (!progress.length) {
                nav.prepend(
                    '<div class="nms-header-loading" role="progressbar" aria-label="Loading page" ' +
                    'aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-hidden="true">' +
                    '<span class="nms-header-loading-fill"></span></div>'
                );
                progress = nav.find('.nms-header-loading').first();
            }

            return progress;
        }

        function clearNMSLoadingTimer(name) {
            if (!nmsLoadingTimers[name]) return;
            window.clearTimeout(nmsLoadingTimers[name]);
            nmsLoadingTimers[name] = null;
        }

        function startNMSLoadingIndicator() {
            var nav = nmsLoadingNav();
            var progress;

            clearNMSLoadingTimer('show');
            clearNMSLoadingTimer('complete');
            clearNMSLoadingTimer('hide');
            if (!nav.length) return;

            nav.removeClass('is-loading is-complete is-finished');
            progress = ensureNMSLoadingIndicator();
            progress.attr({'aria-valuenow': '0', 'aria-hidden': 'true'});
            nmsLoadingVisible = false;

            // Keep fast requests quiet so ordinary interactions do not flash.
            nmsLoadingTimers.show = window.setTimeout(function showNMSLoadingIndicator() {
                var currentNav = nmsLoadingNav();

                nmsLoadingTimers.show = null;
                if (!currentNav.length) return;
                currentNav.addClass('is-loading');
                currentNav.find('.nms-header-loading').attr({'aria-valuenow': '35', 'aria-hidden': 'false'});
                nmsLoadingVisible = true;
                nmsLoadingStartedAt = Date.now();
            }, 120);
        }

        function completeNMSLoadingIndicator() {
            var minimumVisibleTime = 260;
            var elapsed;
            var delay;

            clearNMSLoadingTimer('show');
            if (!nmsLoadingVisible) return;

            elapsed = Date.now() - nmsLoadingStartedAt;
            delay = Math.max(0, minimumVisibleTime - elapsed);
            clearNMSLoadingTimer('complete');
            nmsLoadingTimers.complete = window.setTimeout(function completeNMSLoadingSweep() {
                var nav = nmsLoadingNav();

                nmsLoadingTimers.complete = null;
                if (!nav.length) return;
                nav.removeClass('is-loading').addClass('is-complete');
                nav.find('.nms-header-loading').attr('aria-valuenow', '100');

                clearNMSLoadingTimer('hide');
                nmsLoadingTimers.hide = window.setTimeout(function hideNMSLoadingIndicator() {
                    var currentNav = nmsLoadingNav();

                    nmsLoadingTimers.hide = null;
                    currentNav.addClass('is-finished');
                    currentNav.find('.nms-header-loading').attr('aria-hidden', 'true');
                    nmsLoadingVisible = false;
                }, 320);
            }, delay);
        }

        function getNMSCurrentFragment(history) {
            // The optional loader may observe history before native startup sets its root.
            try {
                if (history && typeof history.getFragment === 'function') {
                    return history.getFragment.call(history);
                }
            } catch (error) {
                // Preserve native navigation; only this observer uses the URL fallback.
            }
            return (window.location.hash || '').replace(/^#!?\/?/, '');
        }

        function installNMSSafeMalformedErrorDiagnostics(layout) {
            if (!layout || layout.nmsSafeMalformedErrorDiagnostics ||
                typeof layout.errorMessageParser !== 'function') {
                return;
            }
            var originalParser = layout.errorMessageParser;
            var parserSource = Function.prototype.toString.call(originalParser);
            // This internal native hook is version-coupled. Do not replace an
            // unknown parser or another extension's diagnostic implementation.
            if (parserSource.indexOf('Impossible to parse backend error - Request') < 0 ||
                parserSource.indexOf('Impossible to parse backend error - Response') < 0) {
                return;
            }
            layout.errorMessageParser = function nmsSafeMalformedErrorParser(jqXhr, messageKeys, options) {
                if (!jqXhr || typeof jqXhr !== 'object') {
                    return originalParser.apply(this, arguments);
                }
                try {
                    JSON.parse(jqXhr.responseText);
                } catch (parseError) {
                    // Native malformed-response handling returns null and logs
                    // request options plus response text. Keep its generic error
                    // path and diagnostics while excluding credentials/body data.
                    return originalParser.call(this,
                        { responseText: '[redacted malformed response]' }, messageKeys);
                }
                return originalParser.apply(this, arguments);
            };
            layout.nmsSafeMalformedErrorDiagnostics = true;
        }

        function installNMSLoadingLifecycle(layout) {
            var originalNavigate;

            if (window.NMSNavbarLoadingInstalled) return;
            window.NMSNavbarLoadingInstalled = true;

            ensureNMSLoadingIndicator();

            jQuery(document)
                .on('click.nmsNavbarLoading', 'a[href]', function startLoadingForNavigation(event) {
                    var anchor = event.currentTarget;
                    var href = anchor.getAttribute('href');
                    var target;

                    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey ||
                        event.shiftKey || event.altKey || anchor.target === '_blank' ||
                        anchor.hasAttribute('download') || !href || href === '#' ||
                        /^(?:javascript:|mailto:|tel:)/i.test(href) ||
                        anchor.getAttribute('data-toggle') || anchor.getAttribute('data-action')) {
                        return;
                    }

                    target = document.createElement('a');
                    target.href = anchor.href;
                    if (target.host === window.location.host && target.href !== window.location.href) {
                        startNMSLoadingIndicator();
                    }
                });

            if (Backbone.history && Backbone.history.navigate && !Backbone.history.nmsLoadingNavigateWrapped) {
                originalNavigate = Backbone.history.navigate;
                Backbone.history.navigate = function navigateWithNMSLoading(fragment, options) {
                    var currentFragment = getNMSCurrentFragment(this);

                    if (String(fragment || '') !== String(currentFragment || '') &&
                        (!options || options.trigger !== false)) {
                        startNMSLoadingIndicator();
                    }
                    return originalNavigate.apply(this, arguments);
                };
                Backbone.history.nmsLoadingNavigateWrapped = true;
            }

            jQuery(window).on('popstate.nmsNavbarLoading hashchange.nmsNavbarLoading', startNMSLoadingIndicator);

            if (layout && typeof layout.on === 'function') {
                layout.on('afterAppendView', function maintainNMSLoadingIndicator() {
                    ensureNMSLoadingIndicator();
                    completeNMSLoadingIndicator();
                });
                layout.on('afterShowContent', completeNMSLoadingIndicator);
            }
        }

        function installNMSSelectorLifecycle() {
            var namespace = '.nmsHeaderSelectorGlide';
            var itemSelector = [
                '.nms-header-products-list > .nms-header-products-item',
                '.nms-header-products-submenu > li',
                '.nms-header-account-section'
            ].join(', ');
            var listSelector = [
                '.nms-header-products-list',
                '.nms-header-products-submenu',
                '.nms-header-account-sections'
            ].join(', ');

            function positionSelector(event) {
                var item = jQuery(event.currentTarget);
                var list = item.parent();
                var selector = list.children('.nms-header-products-selector, .nms-header-account-selector').first();

                if (!selector.length) return;
                list.css({
                    '--nms-header-selector-y': item.position().top + 'px',
                    '--nms-header-selector-height': item.outerHeight() + 'px'
                }).addClass('is-selecting');
            }

            function clearSelector(event) {
                var list = jQuery(event.currentTarget);
                var nextTarget = event.relatedTarget;

                if (nextTarget && (list[0] === nextTarget || jQuery.contains(list[0], nextTarget))) return;
                list.removeClass('is-selecting');
            }

            jQuery(document)
                .off(namespace)
                .on('mouseenter' + namespace + ' focusin' + namespace, itemSelector, positionSelector)
                .on('mouseleave' + namespace + ' focusout' + namespace, listSelector, clearSelector);
        }

        var originalItemsSearcherRender = ItemsSearcherView.prototype.render;

        installIdentifierTranslation();
        ItemsSearcherView.prototype.template = nmsItemsSearcherTpl;
        ItemsSearcherView.prototype.render = function renderNMSItemsSearcher() {
            var result = originalItemsSearcherRender.apply(this, arguments);

            this.$('[data-type="search-input"]').removeAttr('maxlength');

            return result;
        };
        installTemplates();
        installContexts();
        installBehavior();
        installMenuBehavior();
        installAccountMenuBehavior();
        installMiniCartBehavior();
        installLineUpdateErrorRecovery();
        installMiniCartItemBehavior();
        [HeaderView, HeaderMenuView, HeaderMenuMyAccountView, HeaderMiniCartView, HeaderMiniCartItemCellView]
            .forEach(installResolvedEventMap);
        installItemsSearcherTypography();
        installItemsSearcherSearchStability();

        return {
            mountToApp: function mountToApp(container) {
                var layout = container && container.getLayout && container.getLayout();
                installNMSSafeMalformedErrorDiagnostics(layout);

                function delegateHeaderEvents() {
                    var headerView = layout && (layout.headerViewInstance ||
                        (typeof layout.getChildViewInstance === 'function' && layout.getChildViewInstance('Header')));

                    if (headerView && typeof headerView.delegateEvents === 'function') {
                        var patchedEvents = typeof HeaderView.prototype.events === 'function'
                            ? HeaderView.prototype.events.call(headerView)
                            : HeaderView.prototype.events;

                        headerView.events = Object.assign({}, headerView.events || {}, patchedEvents || {});
                        headerView.delegateEvents();
                    }
                }

                delegateHeaderEvents();
                installNMSCancelledEscapeKeyup();
                installNMSSelectorLifecycle();
                jQuery('[data-type="search-input"].itemssearcher-input').removeAttr('maxlength');
                installNMSLoadingLifecycle(layout);
                if (layout && typeof layout.on === 'function') {
                    layout.on('afterAppendView', function maintainNMSHeader() {
                        delegateHeaderEvents();
                        jQuery('[data-type="search-input"].itemssearcher-input').removeAttr('maxlength');
                    });
                }
            }
        };
    }
);
